import { TournamentState } from '@ps/poker-games-tile-mappers';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { usePokerSundayMillionWidget } from '../../../../../model';

import { TXTCLI_N0_BUY_IN, TXTCLI_N0_GTD, TXTCLI_PRIZE_POOL___N0 } from './Content.messages.json';
import styles from './Content.scss';
import Completed from './components/Completed';

const Content: React.FC = () => {
  const { widgetSelect } = usePokerSundayMillionWidget();
  const tournament = useSelector(widgetSelect.getTournament);
  const {
    formattedState: state,
    formattedPrizePool: prizePool,
    formattedBuyIn: buyIn
  } = tournament;

  const showPrizePool =
    state === TournamentState.LATE_REGISTRATION || state === TournamentState.RUNNING;

  if (state === TournamentState.COMPLETED) return <Completed />;
  const tag = showPrizePool ? TXTCLI_PRIZE_POOL___N0 : TXTCLI_N0_GTD;
  return (
    <div className={styles.root}>
      <Translation {...TXTCLI_N0_BUY_IN} values={{ 0: buyIn }} tagName="p" />
      <hr className={styles.divider} />
      <p className={styles.prizePool}>
        <Translation {...tag} values={{ 0: prizePool }} />
      </p>
    </div>
  );
};

export default Content;
